import ru from './locale/ru.json';
import en from './locale/en.json';

export default {
    data() {
        return {
            locale: {
                lang: 'ru',
                messages: { ru, en },

                translate(message, props) {
                    return this.messages[this.lang][message];
                },
            },
        };
    },
};
